import tipsSettingService from 'Services/api/tipsSetting.service'
import useFetchApi, { isLoading } from 'hooks/useFetchApi/useFetchApi'
import { sortBy } from 'lodash-es'
import { QuickTipContract } from 'models/QuickTipContract'
import { TipsSettingContract } from 'models/TipsSettingContract'
import { TipsType } from 'models/TipsType'
import { getDefaultQuickTips } from 'pages/PosPage/TipsSettings/hooks/useTipsSettingForm'
import { useCallback, useMemo } from 'react'
const API_CONFIG = { showErrorToast: true }
const useTipsSetting = () => {
    const [tipsSetting, getTipsSetting, getTipsSettingStatus] = useFetchApi(
        tipsSettingService.getTipsSetting,
        API_CONFIG,
    )

    const [, updateTipsSetting, updateTipsSettingStatus] = useFetchApi(
        tipsSettingService.updateTipsSetting,
        API_CONFIG,
    )

    const getQuickTips = useCallback(
        (type: TipsType) => {
            if (tipsSetting) {
                var quickTips = sortBy(
                    tipsSetting.quickTips?.filter((i) => i.type === type) ?? [],
                    'amount',
                )
                const amountQuickTips = quickTips.length
                if (amountQuickTips < 3) {
                    var addDefaultTips: QuickTipContract[] = []
                    for (let i = 0; i < 3 - amountQuickTips; i++) {
                        addDefaultTips = [
                            ...addDefaultTips,
                            getDefaultQuickTips(
                                type,
                                tipsSetting!.tipsSettingID!,
                            ),
                        ]
                    }
                    quickTips = [...quickTips, ...addDefaultTips]
                }
                return quickTips
            }
            return []
        },
        [tipsSetting],
    )

    const quickTips = useMemo(() => {
        const percentageQuickTips = getQuickTips(TipsType.Percentage)
        const fixedAmountQuickTips = getQuickTips(TipsType.FixedAmount)
        return percentageQuickTips.concat(fixedAmountQuickTips)
    }, [getQuickTips])

    return {
        tipsSetting: {
            ...tipsSetting,
            quickTips: quickTips,
        } as TipsSettingContract,
        getTipsSetting,
        updateTipsSetting,
        loading: isLoading(getTipsSettingStatus),
        onProcessLoading: isLoading(updateTipsSettingStatus),
    }
}

export default useTipsSetting
